/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

/**
 * StockCreationTemplate specifies a template that can be used to auto create a stock item, factors, products and related productsInLocations and stockInLocations. 
 */
export interface StockCreationTemplateView { 
    /**
     * The unique identifier of this record.
     */
    stockCreationTemplateId?: number;
    /**
     * Used to identify the purpose of the template.
     */
    name?: string;
    /**
     * The stock group that this template applies to.
     */
    stockGroupId?: number;
    /**
     * The outer container name used when creating a stock item from this template
     */
    defaultOuterContainerName?: string;
    /**
     * The inner container name when creating a stock item from this template
     */
    defaultInnerContainerName?: string;
    /**
     * The number of inners per outer used when creating a stock item form this template
     */
    defaultInnersPerOuter?: number;
    /**
     * The outers only used when creating a stock item from this template
     */
    defaultOutersOnly?: boolean;
    /**
     * The minimum order quantity used when creating a stock item from this template
     */
    defaultMinimumOrderQuantity?: number;
    /**
     * The millilitres value used when creating a stock item from this template. 
     */
    defaultMillilitres?: number;
    /**
     * The includeInExport value used when creating a stock item from this template.
     */
    defaultIncludeInExport?: boolean;
    /**
     * The variety used when creating a stock item from this template.
     */
    defaultVariety?: string;
    /**
     * The vintage used when creating a stock item form this template.
     */
    defaultVintage?: string;
    /**
     * The vintage used when creating a stock item form this template.
     */
    defaultSize?: string;
    /**
     * The vintage used when creating a stock item form this template.
     */
    defaultRegion?: string;
    /**
     * The vintage used when creating a stock item form this template.
     */
    defaultProducer?: string;
    /**
     * The vintage used when creating a stock item form this template.
     */
    defaultBrand?: string;
    /**
     * The trackingByMethod used when creating a stock item from this template
     */
    defaultTrackByMethod?: number;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    /**
     * 0 = stock, 1 = recipe, default 0
     */
    defaultStockType?: number;
}